document.addEventListener("DOMContentLoaded", (event) => {

  window.scrollTo(0, 0);
  
  // For Firefox
  document.documentElement.style.scrollbarWidth = 'none'; 
  
  // For Chrome, Safari (WebKit)
  const style = document.createElement('style');
  style.innerHTML = `
    html::-webkit-scrollbar,
    body::-webkit-scrollbar {
      display: none;
    }
  `;
  document.head.appendChild(style);

  document.body.classList.add('white');
  document.body.classList.add('bg-F8F5F0');
  
  let isHomeMobile = false;
  window.addEventListener('resize', () => {
    isHomeMobile = (window.matchMedia("(max-width:1199px)").matches) ? true : false;
  });
  window.dispatchEvent(new Event('resize'));
	
	function initFullpage() {

		const container = document.querySelector('.ecom-sections');

		if (!container) return;               // container not loaded yet
		if (container.dataset.fpInit) return; // already initialized

		// Optional: move footer inside fullpage as last section
		const footer = document.querySelector('.shopify-section-group-footer-group');
		if (footer) {
			const footerSection = document.createElement('section');
			footerSection.classList.add('section', 'shopify-footer-section');
			footerSection.appendChild(footer);
			container.appendChild(footerSection);
		}

		// Add .section class to all direct children
		container.querySelectorAll(':scope > *').forEach(el => {
			if (!el.classList.contains('section')) {
				el.classList.add('section');
			}
		});

		// mark as initialized
		container.dataset.fpInit = 'true';

		container.scrollTop = 0;

		setTimeout(() => {
			const homeFullpage = new fullpage('.ecom-sections', {
				licenseKey: '7N0H7-0O9UI-4KJB7-7YJG8-OMTAN',
				credits: {
					enabled: false
				},
				scrollBars: false,
				touchSensitivity: 15,
				autoScrolling: true,
				scrollOverflow: false, // Needed to scroll inside footer section
				responsiveHeight: 0, // let CSS handle section height
				// responsiveWidth: 768, // optional: disables fullPage on small screens
				scrolloverflowmacstyle: false,
				fitToSection: true,
				// autoHeight: true,
				afterLoad: function(origin, destination, direction){

					var section = destination.item;
					var totalSections = document.querySelectorAll('.ecom-sections > .section').length;
					var isSecondToLast = destination.index === totalSections - 2;
					var isLast = destination.index === totalSections - 1;
					if( section && section.getAttribute('data-theme') === 'dark' ){
						document.body.classList.remove('white');
					} else if( isSecondToLast ) {
						document.body.classList.remove('white');
					} else if( isLast ) {
						document.body.classList.add('white');
					} else {
						document.body.classList.add('white');
					}
				},
				afterRender: function () {
					setTimeout(() => {
						document.body.classList.add('loaded');
					}, 200);
					// fullpage_api.moveTo(1);
				},
				onLeave: function (origin, destination, direction) {

						//destination.index;

						// if (direction === 'down') {
						//     document.body.classList.add('down');
						// } else if (direction === 'up') {
						//     document.body.classList.remove('down');
						// }
					
				}
			});
			// homeFullpage.moveSectionDown();
		}, 100);
		// console.log('Fullpage initialized!');
	}
	if( !isHomeMobile) {
		const observerFP = new MutationObserver(initFullpage);
		observerFP.observe(document.body, { childList: true, subtree: true });
	}

});
